export default "import.meta.ROLLUP_FILE_URL_c10363da"